var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading59_container"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"text"},[_vm._v("LOADING")]),_c('div',{staticClass:"box"})])])])
}]

export { render, staticRenderFns }